import { render, staticRenderFns } from "./UmDbBoardList.vue?vue&type=template&id=25bc066e&"
import script from "./UmDbBoardList.vue?vue&type=script&lang=js&"
export * from "./UmDbBoardList.vue?vue&type=script&lang=js&"
import style0 from "./UmDbBoardList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports